import { MouseEvent, ReactElement, ReactNode } from 'react';

import { Row } from '../Row/Row';
import { ButtonContainer } from './style';
import { ButtonColor } from './types';

export interface ButtonProps {
	disabled?: boolean;
	$loading?: boolean;
	$block?: boolean;
	$color: ButtonColor;
	$rounded?: boolean;
	onClick?: (evt: MouseEvent<HTMLButtonElement>) => void;
	prepend?: ReactElement;
	children?: ReactNode;
}

export function Button({
	disabled = false,
	$color = 'primary',
	$block = false,
	$loading = false,
	$rounded = false,
	prepend,
	onClick,
	children,
}: ButtonProps) {
	return (
		<ButtonContainer
			$color={$color}
			$block={$block}
			disabled={disabled}
			$rounded={$rounded}
			$loading={$loading}
			onClick={onClick}
		>
			<Row $gap={21} $vcenter={true}>
				{prepend}
				{children}
			</Row>
		</ButtonContainer>
	);
}
